import { IMEventBus } from "lib/mp-stjk-im-service";

Component({
  /**
   * 组件的属性列表
   */
  properties: {
    content: {
      type: String,
      value: null,
      observer: function (contentStr) {
        let hightTextArray = [],
          simpleTextArray = [],
          splitIndex = 0;
        try {
          const { highlights, tip } = JSON.parse(contentStr);
          if (highlights && highlights.length > 0) {
            highlights.forEach(highlight => {
              const [start, num] = highlight.range
                .split(",")
                .map(item => parseInt(item, 10));
              if (start > tip.length || num > tip.length || num === 0) {
                return;
              }
              hightTextArray.push({
                text: tip.substr(start, num - start + 1),
                color: highlight.color,
                action: highlight.h5
              });
              simpleTextArray.push(
                tip.substring(splitIndex, start)
              );
              splitIndex = start + num;
            });
            if (hightTextArray.length > 0) {
              simpleTextArray.push(tip.substr(splitIndex));
            }
          } else {
            simpleTextArray.push(tip);
          }
        } catch (e) {
          simpleTextArray.push(contentStr);
        }
        this.setData({
          hightTextArray,
          simpleTextArray
        });
      }
    },
    // 是否是续费信息素，跳转需要单独处理
    ixExpireTip: {
      type: Boolean,
      value: false
    }
  },

  /**
   * 组件的初始数据
   */
  data: {
    hightTextArray: [],
    simpleTextArray: []
  },

  /**
   * 组件的方法列表
   */
  methods: {
    /**
     * 处理关键字点击
     */
    handleKeyWordClick: function (event) {
      const jumpUrl = event.currentTarget.dataset.action;
      this.handleJump(jumpUrl);
    },
    /**
     * 跳转
     */
    handleJump: function (h5Url) {
      if (this.data.ixExpireTip) {
        // 续费信息素 需要单独处理跳转逻辑
        IMEventBus.trigger('GO_TO_RENEW_PAGE');
      } else {
        wx.navigateTo({
          url: "/pages/bridge/webview/index?url=" + encodeURIComponent(h5Url)
        });
      }
    }
  }
});
